
import { useState, useEffect } from "react";
import { enrollUserInCourse } from "@/lib/user-courses";
import { toast } from "@/components/ui/use-toast";
import { Purchase } from "@/lib/purchases";

export function useEnrollmentHandler(
  user: { id: string } | null | undefined,
  courseId: string | null,
  purchase: Purchase | null
) {
  const [checkedEnrollment, setCheckedEnrollment] = useState(false);

  // Ensure user is enrolled in the course, but ONLY if purchase/payment was successful
  useEffect(() => {
    const ensureEnrollment = async () => {
      if (!user || !courseId || !purchase || checkedEnrollment) return;
      // Only proceed if payment status is "completed"
      if (
        purchase.payment_status === "completed" ||
        purchase.status === "completed"
      ) {
        try {
          const enrollment = await enrollUserInCourse(user.id, courseId);

          if (enrollment) {
            toast({
              title: "Enrollment Successful",
              description: "You have been enrolled in the course",
            });
            setCheckedEnrollment(true);
          }
        } catch (error) {
          // Enrollment error handling
        }
      }
    };

    ensureEnrollment();
  }, [user, courseId, purchase, checkedEnrollment]);

  return { checkedEnrollment };
}
